/*
Insights: enter stagger, lighter than the bento.
Why: same reason as the bento, three items in sequence.
*/

export function insights(gsap) {
  const items = document.querySelectorAll('.insights__list .insight');

  if (!items.length) return;

  gsap.fromTo(items, { y: 20, opacity: 0 }, {
    y: 0,
    opacity: 1,
    duration: 0.6,
    ease: 'power3.out',
    stagger: 0.1,
    clearProps: 'transform',
    scrollTrigger: { trigger: '.insights__list', start: 'top 85%', once: true },
  });
}
